import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3v8.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V3h18zm-3 8.42l3 3.01V21H3v-8.58l3 2.99 4-4 4 4 4-3.99z"
}), 'BrokenImageSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BrokenImageSharp.js
// module id = 2531
// module chunks = 2